// import React from "react";
// import QRCode from "react-qr-code";

// export default function RewardsManager({ 
//   activeTab, 
//   filteredRewards, 
//   merchant, 
//   customerId, 
//   merchantId, 
//   actionLoading, 
//   handleRedeemReward,
//   filteredRestaurants,
//   handleSelectRestaurant
// }) {
  
//   if (activeTab === "my_rewards") {
//     return (
//       <div style={{ fontFamily: "Inter, system-ui, sans-serif", animation: "fadeIn 0.4s ease" }}>
//         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", flexWrap: "wrap", gap: "15px" }}>
//           <div>
//             <h2 style={{ color: "#111827", fontSize: "28px", fontWeight: "800", letterSpacing: "-0.5px", margin: 0 }}>Available Rewards 🎁</h2>
//             <p style={{ color: "#6b7280", fontSize: "14px", marginTop: "4px", margin: 0 }}>
//               Redeem unlocked vouchers at <b>{merchant?.business_name || "Active Shop"}</b>
//             </p>
//           </div>
//           <span style={{ fontSize: "12px", fontWeight: "700", background: "#f0fdf4", color: "#15803d", padding: "8px 16px", borderRadius: "100px", border: "1px solid #bbf7d0", letterSpacing: "0.5px" }}>
//             ● LIVE VERIFIED SHOP
//           </span>
//         </div>

//         {filteredRewards.length === 0 ? (
//           <div style={{ padding: "60px 40px", background: "#ffffff", borderRadius: "24px", textAlign: "center", border: "1px dashed #e5e7eb" }}>
//             <div style={{ fontSize: "40px", marginBottom: "15px" }}>🎫</div>
//             <h3 style={{ fontSize: "18px", color: "#111827", fontWeight: "700", marginBottom: "6px" }}>No Unlocked Vouchers</h3>
//             <p style={{ color: "#6b7280", fontSize: "14px", maxWidth: "400px", margin: "0 auto", lineHeight: "1.5" }}>
//               No active coupons found for this merchant. Switch your active restaurant from the <b>"My Restaurants"</b> tab to check others.
//             </p>
//           </div>
//         ) : (
//           <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))", gap: "30px" }}>
//             {filteredRewards.map((rewardItem) => {
//               const isUsed = rewardItem.status === "used";
//               const qrPayload = JSON.stringify({
//                 action: "redeem_reward",
//                 coupon_code: rewardItem.coupon_code,
//                 customer_id: customerId,
//                 merchant_id: merchantId,
//                 reward_type: rewardItem.reward
//               });
//               const isNumericReward = !isNaN(rewardItem.reward);

//               return (
//                 <div key={rewardItem.id} className="coupon-card" style={{ background: "#ffffff", borderRadius: "24px", boxShadow: "0 20px 40px rgba(0, 0, 0, 0.03)", border: "1px solid #eef2f6", display: "flex", flexDirection: "column", justifyContent: "space-between", overflow: "hidden" }}>
//                   <div style={{ padding: "24px 24px 20px 24px" }}>
//                     <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
//                       <span style={{ fontSize: "12px", fontWeight: "700", background: "#eff6ff", color: "#2563eb", padding: "6px 14px", borderRadius: "12px", border: "1px solid #bfdbfe" }}>
//                         🏪 {merchant?.business_name || "Partner Store"}
//                       </span>
//                       <span style={{ padding: "6px 14px", borderRadius: "100px", fontSize: "11px", fontWeight: "800", backgroundColor: isUsed ? "#f3f4f6" : "#dcfce7", color: isUsed ? "#6b7280" : "#15803d" }}>
//                         {rewardItem.status.toUpperCase()}
//                       </span>
//                     </div>
//                     <p style={{ fontSize: "13px", color: "#6b7280", margin: "0 0 4px 0", textTransform: "uppercase", fontWeight: "600" }}>Cashback / Value</p>
//                     <h3 style={{ fontSize: isNumericReward ? "32px" : "22px", color: "#111827", margin: "0 0 6px 0", fontWeight: "900", display: "flex", alignItems: isNumericReward ? "baseline" : "center", gap: "4px" }}>
//                       {isNumericReward && <span style={{ fontSize: "20px" }}>₹</span>}
//                       {rewardItem.reward}
//                     </h3>
//                     <p style={{ fontSize: "12px", color: "#9ca3af", margin: 0 }}>Issued: {rewardItem.created_at}</p>
//                   </div>

//                   {/* Premium Ticket Punched Divider Cut */}
//                   <div style={{ position: "relative", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 12px" }}>
//                     <div style={{ position: "absolute", left: "-20px", width: "16px", height: "16px", borderRadius: "50%", background: "#f4f7fb", zIndex: 2 }}></div>
//                     <div style={{ width: "100%", borderTop: "2px dashed #e2e8f0", height: "0" }}></div>
//                     <div style={{ position: "absolute", right: "-20px", width: "16px", height: "16px", borderRadius: "50%", background: "#f4f7fb", zIndex: 2 }}></div>
//                   </div>

//                   <div style={{ padding: "20px 24px 24px 24px", background: "#fafafa" }}>
//                     {!isUsed ? (
//                       <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: "20px" }}>
//                         <div style={{ background: "#ffffff", padding: "16px", borderRadius: "20px", border: "1px solid #e2e8f0", marginBottom: "12px" }}>
//                           <QRCode value={qrPayload} size={140} level="H" />
//                         </div>
//                         <p style={{ fontSize: "12px", color: "#4b5563", fontWeight: "600", margin: 0 }}>⚡ Present QR code to partner at checkout</p>
//                       </div>
//                     ) : (
//                       <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "180px", marginBottom: "20px" }}>
//                         <div style={{ fontSize: "32px", opacity: "0.4" }}>🔒</div>
//                         <p style={{ fontSize: "14px", color: "#9ca3af", fontWeight: "700" }}>Voucher Cleared & Spent</p>
//                       </div>
//                     )}

//                     <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", background: "#ffffff", padding: "12px 16px", borderRadius: "14px", border: "1px solid #e5e7eb" }}>
//                       <span style={{ fontSize: "12px", color: "#6b7280" }}>Voucher Pin:</span>
//                       <span style={{ fontFamily: "monospace", fontWeight: "800", fontSize: "16px", color: "#111827" }}>{rewardItem.coupon_code}</span>
//                     </div>
                    
//                     {!isUsed && (
//                       <button disabled={actionLoading} onClick={() => handleRedeemReward(rewardItem.coupon_code)} style={{ width: "100%", padding: "15px", border: "none", background: "linear-gradient(135deg, #111827, #1f2937)", color: "#ffffff", borderRadius: "14px", fontSize: "14px", fontWeight: "700", cursor: "pointer", marginTop: "16px" }}>
//                         {actionLoading ? "Processing..." : "Verify Manually (Self-Redeem)"}
//                       </button>
//                     )}
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         )}
//       </div>
//     );
//   }

//   // All Connected Restaurants Layout Grid Switcher
//   return (
//     <div className="grid" style={{ animation: "fadeIn 0.4s ease" }}>
//       {filteredRestaurants.map((res) => {
//         const isCurrentlySelected = res.merchant_id === merchantId;
//         return (
//           <div key={res.merchant_id} className="restaurant-card" style={{ border: isCurrentlySelected ? "2px solid #ff8c42" : "1px solid transparent" }}>
//             <div className="restaurant-top">
//               <div className="restaurant-logo">🍽️</div>
//               <div className="status" style={{ backgroundColor: isCurrentlySelected ? "#ffebdb" : "#f3f4f6", color: isCurrentlySelected ? "#ff6b35" : "#4b5563" }}>
//                 {isCurrentlySelected ? "Active Tracking" : "Connected Shop"}
//               </div>
//             </div>
//             <h3>{res.business_name}</h3>
//             <p style={{ textTransform: "capitalize", fontSize: "14px", color: "#9ca3af" }}>Type: {res.business_type} | Owner: {res.owner_name}</p>
//             <p style={{ color: "#4b5563" }}>📍 <b>{res.address}</b></p>
            
//             <div style={{ background: "#f9fafb", padding: "12px", borderRadius: "12px", textAlign: "center", marginTop: "10px" }}>
//               <span style={{ fontSize: "15px", fontWeight: "700", color: "#ff6b35" }}>{res.visits} Total Visits Done</span>
//             </div>

//             {!isCurrentlySelected && (
//               <button className="select-shop-btn" onClick={() => handleSelectRestaurant(res.merchant_id)}>
//                 Switch to Dashboard View 🔄
//               </button>
//             )}
//           </div>
//         );
//       })}
//     </div>
//   );
// }


// import React from "react";
// import QRCode from "react-qr-code";

// export default function RewardsManager({ 
//   activeTab, 
//   filteredRewards, 
//   merchant, 
//   customerId, 
//   merchantId, 
//   actionLoading, 
//   handleRedeemReward,
//   filteredRestaurants,
//   handleSelectRestaurant
// }) {
  
//   if (activeTab === "my_rewards") {
//     return (
//       <div style={{ fontFamily: "Inter, system-ui, sans-serif", animation: "fadeIn 0.4s ease" }}>
//         {/* Tab Header Section */}
//         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", flexWrap: "wrap", gap: "15px" }}>
//           <div>
//             <h2 style={{ color: "#111827", fontSize: "28px", fontWeight: "800", letterSpacing: "-0.5px", margin: 0 }}>Available Rewards 🎁</h2>
//             <p style={{ color: "#6b7280", fontSize: "14px", marginTop: "4px", margin: 0 }}>
//               Redeem unlocked vouchers at <b>{merchant?.business_name || "Active Shop"}</b>
//             </p>
//           </div>
//           <span style={{ fontSize: "12px", fontWeight: "700", background: "#f0fdf4", color: "#15803d", padding: "8px 16px", borderRadius: "100px", border: "1px solid #bbf7d0", letterSpacing: "0.5px" }}>
//             ● LIVE VERIFIED SHOP
//           </span>
//         </div>

//         {/* FIX: Agar database se array khali aa raha h ya filter mismatch h */}
//         {!filteredRewards || filteredRewards.length === 0 ? (
//           <div style={{ padding: "60px 40px", background: "#ffffff", borderRadius: "24px", textAlign: "center", border: "1px dashed #e5e7eb" }}>
//             <div style={{ fontSize: "40px", marginBottom: "15px" }}>🎫</div>
//             <h3 style={{ fontSize: "18px", color: "#111827", fontWeight: "700", marginBottom: "6px" }}>No Unlocked Vouchers</h3>
//             <p style={{ color: "#6b7280", fontSize: "14px", maxWidth: "400px", margin: "0 auto", lineHeight: "1.5" }}>
//               No active coupons found for this merchant. Switch your active restaurant from the <b>"My Restaurants"</b> tab to check others.
//             </p>
//           </div>
//         ) : (
//           /* FIX: Grid distribution check karo taaki saare maps properly itemize ho ske */
//           <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: "25px" }}>
//             {filteredRewards.map((rewardItem, index) => {
//               // Har loop unique key ke sath evaluate hoga
//               const isUsed = rewardItem.status === "used" || rewardItem.status === "Redeemed";
//               const qrPayload = JSON.stringify({
//                 action: "redeem_reward",
//                 coupon_code: rewardItem.coupon_code,
//                 customer_id: customerId,
//                 merchant_id: merchantId,
//                 reward_type: rewardItem.reward
//               });
//               const isNumericReward = !isNaN(rewardItem.reward);

//               return (
//                 <div 
//                   key={rewardItem.id || index} 
//                   className="coupon-card" 
//                   style={{ 
//                     background: "#ffffff", 
//                     borderRadius: "24px", 
//                     boxShadow: "0 15px 35px rgba(0, 0, 0, 0.04)", 
//                     border: "1px solid #eef2f6", 
//                     display: "flex", 
//                     flexDirection: "column", 
//                     justifyContent: "space-between", 
//                     overflow: "hidden",
//                     opacity: isUsed ? 0.85 : 1 // Used wala thoda fade rahega premium feel k liye
//                   }}
//                 >
//                   <div style={{ padding: "24px 24px 20px 24px" }}>
//                     <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
//                       <span style={{ fontSize: "12px", fontWeight: "700", background: "#eff6ff", color: "#2563eb", padding: "6px 14px", borderRadius: "12px", border: "1px solid #bfdbfe" }}>
//                         🏪 {merchant?.business_name || "Partner Store"}
//                       </span>
//                       <span style={{ padding: "6px 14px", borderRadius: "100px", fontSize: "11px", fontWeight: "800", backgroundColor: isUsed ? "#f3f4f6" : "#dcfce7", color: isUsed ? "#6b7280" : "#15803d" }}>
//                         {rewardItem.status ? rewardItem.status.toUpperCase() : "UNLOCKED"}
//                       </span>
//                     </div>
//                     <p style={{ fontSize: "13px", color: "#6b7280", margin: "0 0 4px 0", textTransform: "uppercase", fontWeight: "600" }}>Cashback / Value</p>
//                     <h3 style={{ fontSize: isNumericReward ? "32px" : "20px", color: "#111827", margin: "0 0 6px 0", fontWeight: "900", display: "flex", alignItems: isNumericReward ? "baseline" : "center", gap: "4px" }}>
//                       {isNumericReward && <span style={{ fontSize: "20px" }}>₹</span>}
//                       {rewardItem.reward}
//                     </h3>
//                     <p style={{ fontSize: "12px", color: "#9ca3af", margin: 0 }}>Issued: {rewardItem.created_at || "Just Now"}</p>
//                   </div>

//                   {/* Premium Ticket Punched Divider Cut */}
//                   <div style={{ position: "relative", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 12px" }}>
//                     <div style={{ position: "absolute", left: "-20px", width: "16px", height: "16px", borderRadius: "50%", background: "#f4f7fb", zIndex: 2, borderRight: "1px solid #eef2f6" }}></div>
//                     <div style={{ width: "100%", borderTop: "2px dashed #e2e8f0", height: "0" }}></div>
//                     <div style={{ position: "absolute", right: "-20px", width: "16px", height: "16px", borderRadius: "50%", background: "#f4f7fb", zIndex: 2, borderLeft: "1px solid #eef2f6" }}></div>
//                   </div>

//                   <div style={{ padding: "20px 24px 24px 24px", background: "#fafafa" }}>
//                     {!isUsed ? (
//                       <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: "20px" }}>
//                         <div style={{ background: "#ffffff", padding: "16px", borderRadius: "20px", border: "1px solid #e2e8f0", marginBottom: "12px", boxShadow: "0 5px 15px rgba(0,0,0,0.02)" }}>
//                           <QRCode value={qrPayload} size={130} level="H" />
//                         </div>
//                         <p style={{ fontSize: "12px", color: "#4b5563", fontWeight: "600", margin: 0 }}>⚡ Present QR code to partner at checkout</p>
//                       </div>
//                     ) : (
//                       <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "170px", marginBottom: "20px" }}>
//                         <div style={{ fontSize: "32px", opacity: "0.4", marginBottom: "5px" }}>🔒</div>
//                         <p style={{ fontSize: "14px", color: "#9ca3af", fontWeight: "700", margin: 0 }}>Voucher Cleared & Spent</p>
//                       </div>
//                     )}

//                     <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", background: "#ffffff", padding: "12px 16px", borderRadius: "14px", border: "1px solid #e5e7eb" }}>
//                       <span style={{ fontSize: "12px", color: "#6b7280", fontWeight: "600" }}>Voucher Pin:</span>
//                       <span style={{ fontFamily: "monospace", fontWeight: "800", fontSize: "16px", color: "#111827", letterSpacing: "0.5px" }}>{rewardItem.coupon_code}</span>
//                     </div>
                    
//                     {!isUsed && (
//                       <button disabled={actionLoading} onClick={() => handleRedeemReward(rewardItem.coupon_code)} style={{ width: "100%", padding: "15px", border: "none", background: "linear-gradient(135deg, #111827, #1f2937)", color: "#ffffff", borderRadius: "14px", fontSize: "14px", fontWeight: "700", cursor: "pointer", marginTop: "16px", boxShadow: "0 4px 12px rgba(0,0,0,0.08)" }}>
//                         {actionLoading ? "Processing..." : "Verify Manually (Self-Redeem)"}
//                       </button>
//                     )}
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         )}
//       </div>
//     );
//   }

//   // All Connected Restaurants Layout Grid Switcher
//   return (
//     <div className="grid" style={{ animation: "fadeIn 0.4s ease" }}>
//       {filteredRestaurants.map((res) => {
//         const isCurrentlySelected = res.merchant_id === merchantId;
//         return (
//           <div key={res.merchant_id} className="restaurant-card" style={{ border: isCurrentlySelected ? "2px solid #ff8c42" : "1px solid transparent" }}>
//             <div className="restaurant-top">
//               <div className="restaurant-logo">🍽️</div>
//               <div className="status" style={{ backgroundColor: isCurrentlySelected ? "#ffebdb" : "#f3f4f6", color: isCurrentlySelected ? "#ff6b35" : "#4b5563" }}>
//                 {isCurrentlySelected ? "Active Tracking" : "Connected Shop"}
//               </div>
//             </div>
//             <h3>{res.business_name}</h3>
//             <p style={{ textTransform: "capitalize", fontSize: "14px", color: "#9ca3af" }}>Type: {res.business_type} | Owner: {res.owner_name}</p>
//             <p style={{ color: "#4b5563" }}>📍 <b>{res.address}</b></p>
            
//             <div style={{ background: "#f9fafb", padding: "12px", borderRadius: "12px", textAlign: "center", marginTop: "10px" }}>
//               <span style={{ fontSize: "15px", fontWeight: "700", color: "#ff6b35" }}>{res.visits} Total Visits Done</span>
//             </div>

//             {!isCurrentlySelected && (
//               <button className="select-shop-btn" onClick={() => handleSelectRestaurant(res.merchant_id)}>
//                 Switch to Dashboard View 🔄
//               </button>
//             )}
//           </div>
//         );
//       })}
//     </div>
//   );
// }

import React from "react";
import QRCode from "react-qr-code";

export default function RewardsManager({ 
  activeTab, 
  filteredRewards, 
  merchant, 
  customerId, 
  merchantId, 
  actionLoading, 
  handleRedeemReward,
  filteredRestaurants,
  handleSelectRestaurant,
  onAddReviewClick // 🌟 Parent component se functional link receive kiya
}) {
  
  if (activeTab === "my_rewards") {
    return (
      <div style={{ fontFamily: "Inter, system-ui, sans-serif", animation: "fadeIn 0.4s ease" }}>
        {/* Tab Header Section */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", flexWrap: "wrap", gap: "15px" }}>
          <div>
            <h2 style={{ color: "#111827", fontSize: "28px", fontWeight: "800", letterSpacing: "-0.5px", margin: 0 }}>Available Rewards 🎁</h2>
            <p style={{ color: "#6b7280", fontSize: "14px", marginTop: "4px", margin: 0 }}>
              Redeem unlocked vouchers at <b>{merchant?.business_name || "Active Shop"}</b>
            </p>
          </div>
          <span style={{ fontSize: "12px", fontWeight: "700", background: "#f0fdf4", color: "#15803d", padding: "8px 16px", borderRadius: "100px", border: "1px solid #bbf7d0", letterSpacing: "0.5px" }}>
            ● LIVE VERIFIED SHOP
          </span>
        </div>

        {/* FIX: Agar database se array khali aa raha h ya filter mismatch h */}
        {!filteredRewards || filteredRewards.length === 0 ? (
          <div style={{ padding: "60px 40px", background: "#ffffff", borderRadius: "24px", textAlign: "center", border: "1px dashed #e5e7eb" }}>
            <div style={{ fontSize: "40px", marginBottom: "15px" }}>🎫</div>
            <h3 style={{ fontSize: "18px", color: "#111827", fontWeight: "700", marginBottom: "6px" }}>No Unlocked Vouchers</h3>
            <p style={{ color: "#6b7280", fontSize: "14px", maxWidth: "400px", margin: "0 auto", lineHeight: "1.5" }}>
              No active coupons found for this merchant. Switch your active restaurant from the <b>"My Restaurants"</b> tab to check others.
            </p>
          </div>
        ) : (
          /* FIX: Grid distribution check karo taaki saare maps properly itemize ho ske */
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: "25px" }}>
            {filteredRewards.map((rewardItem, index) => {
              // Har loop unique key ke sath evaluate hoga
              const isUsed = rewardItem.status === "used" || rewardItem.status === "Redeemed";
              const qrPayload = JSON.stringify({
                action: "redeem_reward",
                coupon_code: rewardItem.coupon_code,
                customer_id: customerId,
                merchant_id: merchantId,
                reward_type: rewardItem.reward
              });
              const isNumericReward = !isNaN(rewardItem.reward);

              return (
                <div 
                  key={rewardItem.id || index} 
                  className="coupon-card" 
                  style={{ 
                    background: "#ffffff", 
                    borderRadius: "24px", 
                    boxShadow: "0 15px 35px rgba(0, 0, 0, 0.04)", 
                    border: "1px solid #eef2f6", 
                    display: "flex", 
                    flexDirection: "column", 
                    justifyContent: "space-between", 
                    overflow: "hidden",
                    opacity: isUsed ? 0.85 : 1 // Used wala thoda fade rahega premium feel k liye
                  }}
                >
                  <div style={{ padding: "24px 24px 20px 24px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                      <span style={{ fontSize: "12px", fontWeight: "700", background: "#eff6ff", color: "#2563eb", padding: "6px 14px", borderRadius: "12px", border: "1px solid #bfdbfe" }}>
                        Establishment: {merchant?.business_name || "Partner Store"}
                      </span>
                      <span style={{ padding: "6px 14px", borderRadius: "100px", fontSize: "11px", fontWeight: "800", backgroundColor: isUsed ? "#f3f4f6" : "#dcfce7", color: isUsed ? "#6b7280" : "#15803d" }}>
                        {rewardItem.status ? rewardItem.status.toUpperCase() : "UNLOCKED"}
                      </span>
                    </div>
                    <p style={{ fontSize: "13px", color: "#6b7280", margin: "0 0 4px 0", textTransform: "uppercase", fontWeight: "600" }}>Cashback / Value</p>
                    <h3 style={{ fontSize: isNumericReward ? "32px" : "20px", color: "#111827", margin: "0 0 6px 0", fontWeight: "900", display: "flex", alignItems: isNumericReward ? "baseline" : "center", gap: "4px" }}>
                      {isNumericReward && <span style={{ fontSize: "20px" }}>₹</span>}
                      {rewardItem.reward}
                    </h3>
                    <p style={{ fontSize: "12px", color: "#9ca3af", margin: 0 }}>Issued: {rewardItem.created_at || "Just Now"}</p>
                  </div>

                  {/* Premium Ticket Punched Divider Cut */}
                  <div style={{ position: "relative", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 12px" }}>
                    <div style={{ position: "absolute", left: "-20px", width: "16px", height: "16px", borderRadius: "50%", background: "#f4f7fb", zIndex: 2, borderRight: "1px solid #eef2f6" }}></div>
                    <div style={{ width: "100%", borderTop: "2px dashed #e2e8f0", height: "0" }}></div>
                    <div style={{ position: "absolute", right: "-20px", width: "16px", height: "16px", borderRadius: "50%", background: "#f4f7fb", zIndex: 2, borderLeft: "1px solid #eef2f6" }}></div>
                  </div>

                  <div style={{ padding: "20px 24px 24px 24px", background: "#fafafa" }}>
                    {!isUsed ? (
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: "20px" }}>
                        <div style={{ background: "#ffffff", padding: "16px", borderRadius: "20px", border: "1px solid #e2e8f0", marginBottom: "12px", boxShadow: "0 5px 15px rgba(0,0,0,0.02)" }}>
                          <QRCode value={qrPayload} size={130} level="H" />
                        </div>
                        <p style={{ fontSize: "12px", color: "#4b5563", fontWeight: "600", margin: 0 }}>⚡ Present QR code to partner at checkout</p>
                      </div>
                    ) : (
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "170px", marginBottom: "20px" }}>
                        <div style={{ fontSize: "32px", opacity: "0.4", marginBottom: "5px" }}>🔒</div>
                        <p style={{ fontSize: "14px", color: "#9ca3af", fontWeight: "700", margin: 0 }}>Voucher Cleared & Spent</p>
                      </div>
                    )}

                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", background: "#ffffff", padding: "12px 16px", borderRadius: "14px", border: "1px solid #e5e7eb" }}>
                      <span style={{ fontSize: "12px", color: "#6b7280", fontWeight: "600" }}>Voucher Pin:</span>
                      <span style={{ fontFamily: "monospace", fontWeight: "800", fontSize: "16px", color: "#111827", letterSpacing: "0.5px" }}>{rewardItem.coupon_code}</span>
                    </div>
                    
                    {/* {!isUsed && (
                      <button disabled={actionLoading} onClick={() => handleRedeemReward(rewardItem.coupon_code)} style={{ width: "100%", padding: "15px", border: "none", background: "linear-gradient(135deg, #111827, #1f2937)", color: "#ffffff", borderRadius: "14px", fontSize: "14px", fontWeight: "700", cursor: "pointer", marginTop: "16px", boxShadow: "0 4px 12px rgba(0,0,0,0.08)" }}>
                        {actionLoading ? "Processing..." : "Verify Manually (Self-Redeem)"}
                      </button>
                    )} */}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }

  // All Connected Restaurants Layout Grid Switcher
  return (
    <div className="grid" style={{ animation: "fadeIn 0.4s ease" }}>
      {filteredRestaurants.map((res) => {
        const isCurrentlySelected = res.merchant_id === merchantId;
        return (
          <div key={res.merchant_id} className="restaurant-card" style={{ border: isCurrentlySelected ? "2px solid #ff8c42" : "1px solid transparent" }}>
            <div className="restaurant-top">
              <div className="restaurant-logo">🍽️</div>
              <div className="status" style={{ backgroundColor: isCurrentlySelected ? "#ffebdb" : "#f3f4f6", color: isCurrentlySelected ? "#ff6b35" : "#4b5563" }}>
                {isCurrentlySelected ? "Active Tracking" : "Connected Shop"}
              </div>
            </div>
            <h3>{res.business_name}</h3>
            <p style={{ textTransform: "capitalize", fontSize: "14px", color: "#9ca3af" }}>Type: {res.business_type} | Owner: {res.owner_name}</p>
            <p style={{ color: "#4b5563" }}>📍 <b>{res.address}</b></p>
            
            <div style={{ background: "#f9fafb", padding: "12px", borderRadius: "12px", textAlign: "center", marginTop: "10px", marginBottom: "12px" }}>
              <span style={{ fontSize: "15px", fontWeight: "700", color: "#ff6b35" }}>{res.visits} Total Visits Done</span>
            </div>

            {/* 🌟 ADD REVIEW BUTTON - Sahi space aur premium matching aesthetics ke sath */}
            <div style={{ width: "100%", display: "block", marginBottom: "8px" }} onClick={(e) => e.stopPropagation()}>
              <button
                type="button"
                style={{
                  width: "100%",
                  height: "38px",
                  fontSize: "13px",
                  fontWeight: "600",
                  color: "#ffffff",
                  background: "linear-gradient(135deg, #1e293b, #334155)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "6px",
                  borderRadius: "8px",
                  border: "none",
                  cursor: "pointer",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.05)"
                }}
                onClick={() => {
                  if (typeof onAddReviewClick === "function") {
                    onAddReviewClick(res);
                  }
                }}
              >
                ⭐️ Add Review
              </button>
            </div>

            {!isCurrentlySelected && (
              <button className="select-shop-btn" onClick={() => handleSelectRestaurant(res.merchant_id)} style={{ marginTop: "4px" }}>
                Switch to Dashboard View 🔄
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}